import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import { ExternalLink, ArrowRight } from 'lucide-react';

import SEO from '../components/SEO';
import FadeIn from '../components/FadeIn';
import { useTranslation } from 'react-i18next';

const Projects: React.FC = () => {
  const navigate = useNavigate();
  const { projects } = useData();
  const { t, i18n } = useTranslation();
  return (
    <div className="w-full bg-brand-light">
      <SEO
        pageCode="projects"
        title="Projelerimiz"
        description="Pato Yazılım'ın imza attığı başarılı projeler ve referanslarımız."
        link="/projelerimiz"
      />
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-brand-dark text-center">
        <FadeIn className="container mx-auto px-4 md:px-8">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            {t('projects.heroTitle')}
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            {t('projects.heroDesc')}
          </p>
        </FadeIn>
      </section>

      {/* Projects Grid */}
      <section className="py-24">
        <div className="container mx-auto px-4 md:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, idx) => (
              <FadeIn key={project.id} delay={idx * 0.1}>
                <Link to={i18n.language === 'en' ? `/en/projects/${project.slug}` : `/projelerimiz/${project.slug}`} className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 cursor-pointer block h-full">
                  <div className="relative overflow-hidden h-64">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-brand-dark/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <span
                        className="bg-white text-brand-dark px-6 py-3 rounded-full font-bold flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300"
                      >
                        {t('common.reviewProject')} <ArrowRight size={18} />
                      </span>
                    </div>
                  </div>
                  <div className="p-8">
                    <div className="text-brand-blue text-xs font-bold tracking-wider mb-2">
                      {project.category.toLocaleUpperCase(i18n.language === 'tr' ? 'tr-TR' : 'en-US')}
                    </div>
                    <h3 className="text-2xl font-bold text-brand-dark mb-3 group-hover:text-brand-blue transition-colors">
                      {project.title}
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {project.description}
                    </p>
                  </div>
                </Link>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;